import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_NORMAL_getInstance3dr9ood98owg7 as Codes_NORMAL_getInstance,
  Codes_INTERNAL_ERROR_getInstance295ahssn91b9x as Codes_INTERNAL_ERROR_getInstance,
} from './CloseReason.mjs';
import { Close3tx65evcwi73t as Close } from './Frame.nonJvm.mjs';
import { utf8Truncate258zdrrdcuqgj as utf8Truncate } from './ControlFrames.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *send(frame, $completion) {
  yield* this.get_outgoing_us7o3v_k$().send_44jogj_k$(frame, $completion);
  return Unit_instance;
}
var WebSocketSessionClass;
function WebSocketSession() {
  if (WebSocketSessionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WebSocketSession', VOID, VOID, VOID, [1, 0]);
    WebSocketSessionClass = $;
  }
  return WebSocketSessionClass;
}
function *close(_this__u8e3s4, reason, $completion) {
  reason = reason === VOID ? CloseReason().new_io_ktor_websocket_CloseReason_al0vxu_k$(Codes_NORMAL_getInstance(), '') : reason;
  try {
    yield* _this__u8e3s4.send_sburzs_k$(Close().new_io_ktor_websocket_Frame_Close_zgly5v_k$(reason), $completion);
    yield* _this__u8e3s4.flush_4wsz1p_k$($completion);
  } catch ($p) {
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *closeExceptionally(_this__u8e3s4, cause, $completion) {
  var tmp;
  if (cause instanceof CancellationException()) {
    tmp = CloseReason().new_io_ktor_websocket_CloseReason_al0vxu_k$(Codes_NORMAL_getInstance(), '');
  } else {
    var message = utf8Truncate(cause.toString(), 123);
    tmp = CloseReason().new_io_ktor_websocket_CloseReason_al0vxu_k$(Codes_INTERNAL_ERROR_getInstance(), message);
  }
  var reason = tmp;
  yield* /*#__NOINLINE__*/close(_this__u8e3s4, reason, $completion);
  return Unit_instance;
}
//region block: exports
export {
  send as send1afreql7wqu1y,
  closeExceptionally as closeExceptionally2ucrayfvrq1dt,
  close as close1aubkxuq1mzed,
  WebSocketSession as WebSocketSessionzi1ianvyj32u,
};
//endregion

//# sourceMappingURL=WebSocketSession.mjs.map
